import "./PPGISteelCoils.module.css";
import Header from "@/reusable_sections/Header";
import ProductDetails from "./sections/ProductDetails";
import Footer from "@/reusable_sections/Footer";
export default function PPGISteelCoilsPage() {
  return <div>
      <Header />
      <ProductDetails />
      <Footer />
    </div>;
}